import MutateArticle from "./MutateArticle";

export default MutateArticle